module.exports = __webpack_public_path__ + "static/media/calendar.441b32f7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/resource/img/calendar.svg
// module id = 442
// module chunks = 0